__turbopack_context__.v({
  "logTypeGeneral": "LogTypeColumn-module-scss-module__YdNPlW__logTypeGeneral",
  "logTypeItem": "LogTypeColumn-module-scss-module__YdNPlW__logTypeItem",
});
